import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {MeasurementPrecisionTypes} from "@model";
import {resultTime} from "@utility";

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'resultTime',
    standalone: false
})
export class ResultsTimePipe implements PipeTransform {

  transform(time?: string, measurementPrecisionType?: MeasurementPrecisionTypes | undefined): string {
    return resultTime(time, measurementPrecisionType);
  }
}
